export const navItems = [
  { label: 'Home', href: '/' as const },
  { label: 'Portfolio', href: '/portfolio' as const },
  { label: 'Services', href: '/services' as const },
  { label: 'Blog', href: '/blog' as const },
  { label: 'About', href: '/about' as const },
  { label: 'Contact', href: '/contact' as const },
] as const;
